import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { freezeObject, objectHasDifference } from '../helper/functions';

export interface Form {
  liquidation: any;
  funding: any;
  credit: any;
  commodity: any;
  operational: any;
  disaster: any;
  compliance: any;
  legal: any;
}

export interface FormStore {
  data: Form;
  setForm: (_data: Partial<Form>) => void;
  resetForm: () => void;
  formDirty: (_data: Partial<Form>) => boolean;
}

export type FormType =
  | 'liquidation'
  | 'funding'
  | 'credit'
  | 'commodity'
  | 'operational'
  | 'disaster'
  | 'compliance'
  | 'legal';

const defaultForm: Form = {
  liquidation: {},
  funding: {},
  credit: {},
  commodity: {},
  operational: {},
  disaster: {},
  compliance: {},
  legal: {},
};

const useFormStore = create<FormStore>()(
  persist(
    (set, get) => ({
      data: freezeObject(defaultForm),
      setForm: (value: Partial<Form>) => {
        set({ data: { ...get().data, ...value } });
      },
      resetForm: () => set(freezeObject(defaultForm)),
      formDirty: (value: Partial<Form>) => {
        return objectHasDifference(defaultForm, value);
      },
    }),
    {
      name: 'form-store',
      storage: createJSONStorage(() => localStorage),
    }
  )
);

export default useFormStore;
